import React from 'react';
import s from './appsStatistics.module.scss'
import {commonClicksStatsOrderingList, dashboardAppsColumnsList} from "../../../../../utils/vars/params";
import ParamsSort from "../../../../../components/ParamsSort/ParamsSort";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {dashboardSelector} from "../../../../../redux/slices/dashboardSlice";
import EmptyList from "../../../../../components/EmptyList/EmptyList";
import CustomSkeleton from "../../../../../components/UiKit/CustomSkeleton/CustomSkeleton";

const AppsStatistics = () => {

    const {topAppsList, topAppsPending} = useSelector(dashboardSelector);

    const {t} = useTranslation()

    return (
        <div className={s.appsStatisticsContainer}>
            {
                topAppsList.length === 0 && !topAppsPending ? (
                    <EmptyList/>
                ) : topAppsPending ? (
                    <section className={s.body}>
                        <table>
                            <thead>
                            <tr>
                                {dashboardAppsColumnsList.map(({name}) => (
                                    <th key={name}>
                                        <div className={s.headerContent}>
                                            {t(name)}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                            </thead>
                        </table>
                        <div className={s.skeletonWrapper}>
                            <CustomSkeleton styles={s.skeletonTable}/>
                        </div>
                    </section>
                ) : (
                    <section className={s.body}>
                        <table>
                            <thead>
                            <tr>
                                {/*topAppsPending*/}
                                {dashboardAppsColumnsList.map(({name}) => (
                                    <th key={name}>
                                        <div className={s.headerContent}>
                                            {t(name)}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {
                                topAppsList.map((item) => {
                                    const {
                                        app,
                                        clicks_count,
                                        id,
                                        installs,
                                        leads,
                                        percentage,
                                        sales,
                                        unique_clicks
                                    } = item

                                    return (
                                        <tr key={id}>
                                            <td className={s.percentageTd}>{percentage}%</td>
                                            <td>{app}</td>
                                            <td>{clicks_count}</td>
                                            <td>{unique_clicks}</td>
                                            <td>{installs}</td>
                                            <td>{leads}</td>
                                            <td>{sales}</td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </section>
                )
            }

        </div>
    )
}

export default AppsStatistics;